'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.numbersOnly = numbersOnly;
exports.format = format;
exports.formatPrice = formatPrice;
exports.stringFormat = stringFormat;
exports.getDecimals = getDecimals;
exports.isMaxWidth = isMaxWidth;
exports.scrollTo = scrollTo;
exports.scrollToTop = scrollToTop;

var _globalize = require('globalize');

var _globalize2 = _interopRequireDefault(_globalize);

var _settings = require('./settings');

var _settings2 = _interopRequireDefault(_settings);

var _smoothScroll = require('./modules/smooth-scroll');

var _smoothScroll2 = _interopRequireDefault(_smoothScroll);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function numbersOnly(e) {
    var value = e.target.value;
    value = value.replace(/\D/g, '');
    if (e.target.value !== value) {
        e.target.value = value;
    }
}

function format(value, format) {
    try {
        return _globalize2.default.format(value, format || 'C0');
    } catch (err) {
        return value;
    }
}

function formatPrice(value, formatType, specifier) {
    var decimals = getDecimals(formatType);
    return format(value, (specifier || 'C') + decimals);
}

function stringFormat(str) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
    }

    return str.replace(/{(\d+)(:(\w\d?))?}/g, function (match, n, s, f) {
        var val = args[n];
        return typeof val !== 'undefined' ? f ? format(val, f) : val : match;
    });
}

function getDecimals(priceType) {
    var pricesSettings = _settings2.default.get().prices || { decimals: {} };
    var vals = [pricesSettings.decimals[priceType], pricesSettings.defaultDecimals];
    for (var i = 0; i < vals.length; i++) {
        if (typeof vals[i] === 'number') return vals[i];
    }
    return 0;
}

// isMaxWidth return true/false
// screen: string - is equivalent to bootstrap values
// viz Content\sass\vendors\boostrap\_variables.scss  row 209
function isMaxWidth(screen) {
    if (window.matchMedia === undefined || screen === undefined) return;

    switch (screen) {
        case 'xs':
            return window.matchMedia("(max-width: 575px)").matches;
            break;
        case 'sm':
            return window.matchMedia("(max-width: 767px)").matches;
            break;
        case 'md':
            return window.matchMedia("(max-width: 991px)").matches;
            break;
        case 'lg':
            return window.matchMedia("(max-width: 1199px)").matches;
            break;
        default:
            return window.matchMedia(screen).matches;
            break;
    }
}

function scrollTo(elm) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    // document.querySelector just select first one
    var anchor = document.querySelector(elm);
    if (anchor === null) return;
    _smoothScroll2.default.animateScroll(anchor, null, { offset: offset });
}

function scrollToTop() {
    if (!isMaxWidth('sm')) {
        scrollTo('.cart');
    }
}


//////////////////
// WEBPACK FOOTER
// ./~/linksoft-albatros/src/utils.js
// module id = 470
// module chunks = 0